module.exports = __webpack_public_path__ + "img/spinner.6fb8eec4.gif";